// components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaInstagram,
  FaArrowRight
} from "react-icons/fa";

// Logo import
import Logo from "../assets/logo.png";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "Anasayfa", path: "/" },
    { label: "Gitarlar", path: "/gitarlar" },
    { label: "Sipariş & Takas", path: "/siparis" },
    { label: "Hakkımızda", path: "/hakkimizda" },
  ];

  const handleWhatsAppClick = () => {
    const phoneNumber = "+905308648486";
    const message = "Merhaba, Neo Guitar Store'dan bilgi almak istiyorum.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const openInstagram = () => {
    window.open("https://instagram.com/neoguitarstore", "_blank");
  };

  const openGoogleMaps = () => {
    window.open("https://maps.app.goo.gl/KG6z2CFfaoz7scSZ9?g_st=aw", "_blank");
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Ana Footer İçeriği */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo ve Açıklama */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={Logo} 
                alt="Neo Guitar Store Logo" 
                className="w-60 h-12 object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm mb-8 max-w-xl leading-relaxed">
              Müzik tutkunları için en kaliteli elektro gitarları sunuyoruz. 
              Profesyonel müzisyenlerden başlangıç seviyesine kadar her seviyeye uygun 
              enstrümanlar ve custom gitar üretimi ile hizmetinizdeyiz.
            </p>
            
            {/* Instagram Butonu */}
            <button
              onClick={openInstagram}
              className="group flex items-center gap-3 px-6 py-3 bg-gray-800 hover:bg-gray-700 rounded-lg border border-gray-700 transition-all duration-300"
            >
              <div className="p-2 rounded-lg bg-gradient-to-br from-purple-600 to-pink-600">
                <FaInstagram className="text-white" />
              </div>
              <div className="text-left">
                <div className="font-medium text-gray-300">Instagram'da Takip Edin</div>
                <div className="text-sm text-white group-hover:text-gray-300 transition-colors">
                  @neoguitarstore
                </div>
              </div>
              <FaArrowRight className="ml-auto text-gray-400 group-hover:text-white transition-all" />
            </button>
          </div>

          {/* Hızlı Linkler */}
          <div>
            <h3 className="font-bold text-lg mb-6 text-white">Hızlı Linkler</h3>
            <ul className="space-y-4">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="group flex items-center gap-3 text-gray-400 hover:text-white transition-all duration-300"
                  >
                    <span className="group-hover:translate-x-1 transition-transform">
                      {link.label}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h3 className="font-bold text-lg mb-6 text-white">İletişim</h3>
            <div className="space-y-6">
              <button 
                onClick={() => window.open('tel:+905308648486', '_blank')}
                className="group flex items-center gap-3 w-full text-left"
              >
                <div className="p-3 rounded-lg bg-gray-800 group-hover:bg-gray-700 transition-all">
                  <FaPhoneAlt className="text-gray-300" />
                </div>
                <div>
                  <div className="text-sm text-gray-400">Telefon</div>
                  <div className="text-gray-300 group-hover:text-white transition-colors">+90 530 864 84 86</div>
                </div>
              </button>

              <button 
                onClick={() => window.open('mailto:info@neoguitarstore.com', '_blank')}
                className="group flex items-center gap-3 w-full text-left"
              >
                <div className="p-3 rounded-lg bg-gray-800 group-hover:bg-gray-700 transition-all">
                  <FaEnvelope className="text-gray-300" />
                </div>
                <div>
                  <div className="text-sm text-gray-400">E-posta</div>
                  <div className="text-gray-300 group-hover:text-white transition-colors">info@neoguitarstore.com</div>
                </div>
              </button>

              <button 
                onClick={openGoogleMaps}
                className="group flex items-center gap-3 w-full text-left"
              >
                <div className="p-3 rounded-lg bg-gray-800 group-hover:bg-gray-700 transition-all">
                  <FaMapMarkerAlt className="text-gray-300" />
                </div>
                <div>
                  <div className="text-sm text-gray-400">Adres</div>
                  <div className="text-gray-300 group-hover:text-white transition-colors">İstanbul, Üsküdar</div>
                </div>
              </button>
            </div>

            {/* WhatsApp Butonu */}
            <button
              onClick={handleWhatsAppClick}
              className="w-full mt-8 flex items-center justify-center gap-3 px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-all duration-300"
            >
              <FaWhatsapp className="text-xl" />
              <span className="font-bold">WhatsApp'tan Yazın</span>
            </button>
          </div>
        </div>
      </div>

      {/* Alt Footer */}
      <div className="border-t border-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-400 text-sm">
              © {currentYear} <span className="text-white font-semibold">Neo Guitar Store</span>. Tüm hakları saklıdır.
            </div>
            
            <div className="flex gap-6 text-sm text-gray-400">
              <Link to="/gizlilik" className="hover:text-white transition-colors">
                Gizlilik
              </Link>
              <Link to="/kosullar" className="hover:text-white transition-colors">
                Kullanım Koşulları
              </Link>
              <Link to="/iade" className="hover:text-white transition-colors">
                İade & Değişim
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}